import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import {
  compose,
  isRequired,
  makeIsNoLongerThan,
} from '@monorepo/shared/utils/validators';
import { MAX_FORM_TEMPLATE_FIELD_NAME_LENGTH } from 'mapistry-shared';
import React from 'react';
import { ModalFieldWrapper, ModalTextField } from '../../styled';

type EditNameFieldProps = {
  prefix?: string;
};

// this is rendered within FinalForm so the inputs are managed by it
export function EditNameField({ prefix }: EditNameFieldProps) {
  return (
    <ModalFieldWrapper>
      <ModalTextField
        label="Field Name"
        name={getFieldNameWithPrefix('name', prefix)}
        validate={compose(
          isRequired,
          makeIsNoLongerThan(MAX_FORM_TEMPLATE_FIELD_NAME_LENGTH),
        )}
        required
        dontSaveSpaceForErrorText
      />
    </ModalFieldWrapper>
  );
}
